<script>
export default {
  data() {
    return {
      title: "",
      focused: false,
    };
  },
  computed: {
    user() {
      return this.$store.getters.userLoggedIn;
    },
  },
  methods: {
    createCard() {
      const title = this.title.trim();
      if (title === "") return;

      console.log("createCard");
      const card = {
        title,
        createdBy: this.user.id,
      };

      this.$emit("createCard", card);
      this.title = "";
    },
    cancelTask(ev) {
      this.title = "";
      this.focused = false;
      ev.target.blur();
    },
  },
};
</script>
<template>
  <div>
    <hr />
    <div class="task-container" :class="{ focused: focused }">
      <i v-if="!focused" class="fas fa-plus-circle task-icon"></i>
      <textarea
        class="task"
        v-model="title"
        @keydown.tab="createCard"
        @keyup.enter="createCard"
        @keyup.esc="cancelTask"
        @focus="focused = true"
        @blur="focused = false"
        :placeholder="
          !focused ? 'Nueva tarjeta' : 'Ingrese un título para esta tarjeta...'
        "
      ></textarea>
    </div>
    <div class="controls" :class="{ focus: focused }">
      <vs-button class="mr-1" @click="createCard">Crear</vs-button>
      <vs-button danger class="" @click="cancelTask">Cancelar</vs-button>
    </div>
  </div>
</template>

<style scoped>
.task-container {
  position: relative;
  display: flex;
  align-items: center;
  border-radius: 5px;
  transition: 0.5s;
  background-color: transparent;
}

.task-container.focused {
  background-color: var(--lego-light-hover);
}

.task-icon {
  position: absolute;
  left: 0.5rem;
  color: var(--lego-gris);
  font-size: 0.9rem;
  z-index: 1;
}

.dark .task-icon {
  color: white;
}

.task {
  width: 100%;
  border-radius: 5px;
  background-color: transparent;
  transition: 0.5s;
  border: none;
  /* outline: 1px solid var(--primary); */
  resize: none;
  padding: 0.5rem;
  padding-left: 2rem;
  height: 2rem;
}
.dark .task {
  color: white;
}

.task:not(:focus)::placeholder {
  /* color: var(--primary) !important; */
  /* text-align: center; */
  font-weight: normal;
}

.task:focus {
  outline: none;
  height: 4rem;
}

.task::-webkit-scrollbar {
  width: 0;
  visibility: hidden;
}

.controls {
  visibility: hidden;
  display: flex;
  margin-top: 0.5rem;
  transition: 0.3s;
  height: 0;
}
.controls.focus {
  visibility: visible;
  height: 40px;
}
</style>
